import Vue from 'vue'
import VueQuill from 'vue-quill'

Vue.use(VueQuill)
